import {Alert,  Snackbar} from '@mui/material';
import { useAppSelector,useAppDispatch } from '../stores/hooks';
import { closealert } from '../stores/notificationslice';
import Slide, { SlideProps } from '@mui/material/Slide';

function TransitionUp(props: SlideProps) {
    return <Slide {...props} direction="up" />;
  }
export default function Notification(){
    const dispatch=useAppDispatch();
  const isAlertShown = useAppSelector((state) => state.notificationReducer.IsOpen);
  const alertMessage = useAppSelector((state) => state.notificationReducer.Message);
  const alertType = useAppSelector((state) => state.notificationReducer.Type);
    return(
        <Snackbar anchorOrigin={{horizontal:'center',vertical:'top'}} TransitionComponent={TransitionUp}
        open={isAlertShown} autoHideDuration={6000} 
        onClose={()=>dispatch(closealert())}>
        <Alert onClose={()=>dispatch(closealert())} severity={alertType} sx={{ width: '100%' }}>
          {alertMessage}
        </Alert>
      </Snackbar>
    )
}